import { render } from "./EditDispatchModal1.vue?vue&type=template&id=abc317e0&scoped=true"
import script from "./EditDispatchModal1.vue?vue&type=script&lang=js"
export * from "./EditDispatchModal1.vue?vue&type=script&lang=js"

import "./EditDispatchModal1.vue?vue&type=style&index=0&id=abc317e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc317e0"]])

export default __exports__